import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', showText = true, className = '' }) => {
  const sizeClasses = {
    sm: 'w-5 h-5',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-xl'
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <div className="p-2 bg-gradient-to-br from-n8n-primary-500 to-n8n-primary-600 rounded-lg shadow-lg">
        <img 
          src="/logo.png" 
          alt="KRNL Studio" 
          className={sizeClasses[size]} 
        />
      </div>
      {showText && (
        <div>
          <h1 className={`font-bold text-n8n-dark-50 tracking-tight ${textSizeClasses[size]}`}>
            KRNL Studio
          </h1>
        </div>
      )}
    </div>
  );
};

export default Logo;
